export enum UserGroupCombineMethod {
    Any,
    All,
}
